import { createAction, props } from '@ngrx/store';
import { IRemoveBankRequest, IRemoveBankResponse } from '../models/employee-bank-detail.model';

export const removeBank = createAction(
  '[Bank] Remove Bank',
  props<{ customerId: string, userProfileBankAccountId: string }>()
);

export const removeBankSuccess = createAction(
  '[Bank] Remove Bank Success',
  props<{ response: IRemoveBankResponse }>()
);

export const removeBankFailure = createAction(
  '[Bank] Remove Bank Failure',
  props<{ error: any }>()
);